const mergeInstructions = (pairOne, pairTwo) => {
  const instructions = [];
  if (pairOne && pairOne.instructions.length) instructions.push(pairOne);
  if (pairTwo && pairTwo.instructions.length) instructions.push(pairTwo);

  return instructions;
};

export default mergeInstructions;
